
const state ={
    clientToModal: '',
    hora: false,
    editable: false,
    updateCalendar: false,

}
const getters ={
   getClientToModal: state => state.clientToModal,
   getHour: state => state.hora,
   getEditable: state => state.editable,
   remoteUpdateCalendar: state => state.updateCalendar
}
const actions={
    storeHour(state, hora){
        state.state.hora = hora;
        state.state.editable = !state.state.editable;
    },
    setClientToModal(state,client){
        state.state.clientToModal = client;
    },
    remoteUpdateCalendar(state){
	state.state.updateCalendar = !state.state.updateCalendar;
    },
}

const mutations = {}

export default {
    state,
    getters,
    actions,
    mutations
}